export default class Format {
  static DATE = "YYYY-MM-DD";
  static TIMESTAMP = "MMM D, YYYY hh:mmA";
  static DISPLAY = "MM/DD/YYYY";
}
